import React from 'react';
import styles from './ThemeFieldWrapper.scss';

interface ThemeFieldWrapperProps {
  children: React.ReactNode;
  fieldLabel: string;
  fieldValue: string;
}

const ThemeFieldWrapper = ({ children, fieldLabel, fieldValue }: ThemeFieldWrapperProps) => {
  return (
    <div className={styles.ThemeFieldWrapper__container}>
      <div className={styles.ThemeFieldWrapper__Field} data-testid="ThemeFieldWrapper__Field">
        <div data-testid="ThemeFieldWrapper__Field__Label">{fieldLabel}:</div>
        <div className={styles.ThemeFieldWrapper__Field__Value} data-testid="ThemeFieldWrapper__Field__Value">
          {fieldValue}
        </div>
      </div>
      {children}
    </div>
  );
};

export default ThemeFieldWrapper;
